import type React from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './Button.module.css';

const Button = ({
  label,
  name,
  onClick,
  btnType,
  btnStyle,
  customClassName,
  btnSize = 'lg',
  type,
  icon,
  disabled,
  form,
}: {
  label?: string | React.ReactNode;
  name?: string;
  onClick?: (e?: any) => void;
  btnType?: string;
  btnStyle: string;
  customClassName?: string;
  btnSize?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  icon?: React.ReactNode;
  disabled?: boolean;
  form?: string;
}) => {
  return (
    <button
      className={twMerge([styles[btnStyle], styles[btnSize], customClassName, disabled ? 'cursor-not-allowed' : 'cursor-pointer'])}
      name={name}
      onClick={onClick}
      type={type}
      disabled={disabled}
      form={form}
    >
      {icon && <span className='h-5 w-5'>{icon}</span>}
      {label && <span className={`${icon ? 'pr-1' : ''}`}>{label}</span>}
    </button>
  );
};

export default Button;
